<script setup>
import SiteFooter from '../components/layout/SiteFooter.vue'
import SiteHeader from '../components/layout/SiteHeader.vue'
import ProductModelStage from '../components/home/ProductModelStage.vue'
</script>

<template>
  <div class="home-page">
    <SiteHeader />

    <main id="main-content" class="home-hero">
      <section class="home-hero__copy">
        <h1 class="home-hero__title">CIPOPO桌面精灵</h1>
        <p class="home-hero__subtitle">让生活更有趣，让智能更贴近人们，让用户更专注自己</p>
      </section>

      <ProductModelStage />
    </main>

    <SiteFooter />
  </div>
</template>

<style scoped>
.home-page {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background: #ffffff;
}

.home-hero {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 48px;
  min-height: 0;
  padding: clamp(32px, 6vh, 72px) clamp(20px, 5vw, 48px) clamp(24px, 4vh, 40px);
  background: linear-gradient(180deg, #ffffff 0%, #f8ffd9 100%);
}

.home-hero__copy {
  align-self: center;
  width: min(100%, 920px);
  text-align: center;
}

.home-hero__title {
  margin: 0;
  color: #000000;
  font-size: clamp(32px, 5vw, 56px);
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.2;
}

.home-hero__subtitle {
  max-width: 720px;
  margin: 16px auto 0;
  color: rgba(0, 0, 0, 0.72);
  font-size: clamp(14px, 2vw, 18px);
  font-weight: 400;
  line-height: 1.7;
}

.home-hero :deep(.product-visual) {
  flex: 1;
  align-self: center;
  width: 100%;
  min-height: 0;
  aspect-ratio: unset;
}
</style>
